var mainDOTD = function(){
	const helpers = new formHelpers4i();
	const currentDeal = new dealsDOTD();
	const thirdParty = new thirdPartyDOTD();
	const pwa = new pwaDOTD();

	const init = async () => {
		pwa.Init();
		initPushOptInAccordion();
		thirdParty.Check();
		await loadDeal();
		await loadSideContent();
	},
	showBusy = () => {
		const dealContainer = document.getElementById("ProductDetails");
		helpers.ShowLoadingOverlay(dealContainer);
	},
	initPushOptInAccordion = () => {
		const pushOptInsSection = document.getElementById("pushOptInOut");
		const accordions = new getAccordions4i();
		accordions.init(pushOptInsSection);
	},
	loadDeal = () => {
		if (document.getElementById('ProductDetails') !== null){
			showBusy();
			currentDeal.Init();
		}
	},
	loadSideContent = () => {
		if (document.getElementById("subscribePnl") !== null){
			const subscribe = new subscriptionDOTD();
			subscribe.Init();
		}
		if (document.getElementById("recommendPnl") !== null){
			const recommend = new recommendDOTD();
			recommend.Init();
		}
		if (document.getElementById("suggestPnl") !== null){
			const suggestion = new suggestionDOTD();
			suggestion.Init();
		}
	};
	return{
		Init: init
	};
};

(function(){
	const dotd = new mainDOTD();
	dotd.Init();
})();